import { founded_item } from "./index.js";
import { surface_style_fill_area } from "./index.js";
import { surface_style_boundary } from "./index.js";
import { surface_style_silhouette } from "./index.js";
import { surface_style_segmentation_curve } from "./index.js";
import { surface_style_control_grid } from "./index.js";
import { surface_style_parameter_line } from "./index.js";
import { surface_style_rendering } from "./index.js";
import { stepExtractOptional, stepExtractArrayToken, stepExtractArrayBegin, skipValue, } from "../../step/parsing/step_deserialization_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class surface_side_style extends founded_item {
    get type() {
        return EntityTypesAP214.SURFACE_SIDE_STYLE;
    }
    get name() {
        if (this.name_ === void 0) {
            this.name_ = this.extractString(0, false);
        }
        return this.name_;
    }
    get styles() {
        if (this.styles_ === void 0) {
            let cursor = this.getOffsetCursor(1);
            const buffer = this.buffer;
            const endCursor = buffer.length;
            if (stepExtractOptional(buffer, cursor, endCursor) === null) {
                return [];
            }
            const value = [];
            let signedCursor0 = stepExtractArrayBegin(buffer, cursor, endCursor);
            cursor = Math.abs(signedCursor0);
            while (signedCursor0 >= 0) {
                const value1Untyped = this.extractBufferReference(buffer, cursor, endCursor);
                if (!(value1Untyped instanceof surface_style_fill_area) && !(value1Untyped instanceof surface_style_boundary) && !(value1Untyped instanceof surface_style_silhouette) && !(value1Untyped instanceof surface_style_segmentation_curve) && !(value1Untyped instanceof surface_style_control_grid) && !(value1Untyped instanceof surface_style_parameter_line) && !(value1Untyped instanceof surface_style_rendering)) {
                    throw new Error("Value in select must be populated");
                }
                const value1 = value1Untyped;
                if (value1 === void 0) {
                    throw new Error("Value in STEP was incorrectly typed");
                }
                cursor = skipValue(buffer, cursor, endCursor);
                value.push(value1);
                signedCursor0 = stepExtractArrayToken(buffer, cursor, endCursor);
                cursor = Math.abs(signedCursor0);
            }
            this.styles_ = value;
        }
        return this.styles_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
surface_side_style.query = [EntityTypesAP214.SURFACE_SIDE_STYLE];
surface_side_style.expectedType = EntityTypesAP214.SURFACE_SIDE_STYLE;
